import * as React from "react";
import { ViewStyle } from "react-native";
import { theme } from "@theme";
import LArtwork, { type Transition } from "./LArtwork";
import LBox, { LBoxProps } from "./LBox";
import DefaultAvatar from "./DefaultAvatar";

interface UserAvatarProps extends LBoxProps {
  image?: string | null;
  defaultAvatarColors?: [string, string] | null;
  style?: ViewStyle;
  size?: number;
  borderColor?: keyof typeof theme.colors;
  imageCacheKey?: string;
  border?: boolean;
  userAvatar?: boolean;
  imageSize?: "small" | "medium" | "large";
  blurhash?: string | null;
  borderRadius?: keyof typeof theme.borderRadii;
  transition?: Transition;
}

const UserAvatar = ({
  image,
  defaultAvatarColors,
  style,
  size = 150,
  border,
  imageSize,
  blurhash,
  borderRadius = "max",
  transition,
  ...rest
}: UserAvatarProps) => {
  return (
    <LBox
      width={size}
      height={size}
      borderRadius={borderRadius}
      overflow="hidden"
      alignItems="center"
      alignSelf="center"
      justifyContent="center"
      borderWidth={border ? 2 : 0}
      borderColor={"white"}
      style={style}
      {...rest}
    >
      {defaultAvatarColors && image ? (
        <DefaultAvatar
          colors={defaultAvatarColors}
          imageUrl={image}
          size={size}
        />
      ) : (
        <LArtwork
          url={image}
          size={size}
          priority="high"
          userAvatar
          imageSize={imageSize}
          blurhash={blurhash}
          transition={transition}
        />
      )}
    </LBox>
  );
};

export default UserAvatar;
